import { TermName } from '@qv-term/enums';


export class TermVisibilityChanges {
  constructor(
    public terms: TermName[],
    public isVisible: boolean
  ) {}
}
